import { defineMessages, useIntl } from 'react-intl';

import { openChatWindow } from '../../actions/livechat';
import config from '../../config';
import { useAppDispatch } from '../../store';
import {
  getEmployerSupportHelpCenterRequestUrl,
  isEmployerSupportWorkingHours,
} from '../helpers/employerSupportWorkingHours';

export const messages = defineMessages({
  textHello: {
    id: 'text-access-glints-employers-help',
    defaultMessage:
      "Hello, I'm currently accessing Glints for Employers website and I need help",
  },
});

const useOpenChatSupport = () => {
  const dispatch = useAppDispatch();

  const { formatMessage } = useIntl();

  const prefilledMessage = encodeURIComponent(
    formatMessage(messages.textHello)
  );

  return (customMessage?: string | unknown) => {
    if (!isEmployerSupportWorkingHours()) {
      window.open(
        getEmployerSupportHelpCenterRequestUrl(config.COUNTRY),
        '_blank',
        'noopener,noreferrer'
      );
      return;
    }

    const message =
      typeof customMessage === 'string'
        ? encodeURIComponent(customMessage)
        : prefilledMessage;

    if (window.zE) {
      dispatch(openChatWindow());
      return;
    }

    window.open(
      `mailto:hi@glints.com?subject=${message}`,
      '_blank',
      'noopener,noreferrer'
    );
  };
};

export default useOpenChatSupport;
